import {
  CONNECT_WALLET_START,
  CONNECT_WALLET_END,
  CONNECT_WALLET_PROVIDER,
  CONNECT_WALLET_PROVIDER_SUCCESS,
  CONNECT_WALLET_PROVIDER_FAILURE,
  CLEAR_ACCOUNT,
  SET_ACCOUNT,
} from 'redux/actionTypes/walletActionTypes';
import { LS_ACCOUNT } from '../../constants/general';

const lsAccountType = localStorage.getItem(LS_ACCOUNT);

const INITIAL_STATE = {
  connectingWallet: false,
  connectingWalletAccountType: '',

  connectingWalletProvider: false,
  connectingWalletProviderError: '',

  account: '',
  accountType: lsAccountType || '',
  additions: {},
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case CONNECT_WALLET_START:
      return { ...state, connectingWallet: true, connectingWalletAccountType: payload };

    case CONNECT_WALLET_END:
      return { ...state, connectingWallet: false, connectingWalletAccountType: '' };

    case CONNECT_WALLET_PROVIDER:
      return { ...state, connectingWalletProvider: true, connectingWalletProviderError: '' };

    case CONNECT_WALLET_PROVIDER_SUCCESS:
      return {
        ...state,
        connectingWalletProvider: false,
        connectingWalletProviderError: '',
        ...payload,
      };

    case CONNECT_WALLET_PROVIDER_FAILURE:
      return {
        ...state,
        connectingWalletProvider: false,
        connectingWalletProviderError: payload,
      };

    case SET_ACCOUNT:
      return {
        ...state,
        account: action.payload,
      };

    case CLEAR_ACCOUNT:
      return {
        ...state,
        account: '',
        accountType: '',
        additions: {},
      };

    default:
      return state;
  }
};
